import React from 'react';
import { connect } from 'react-redux';

import CustomHead from '@components/customHead/CustomHead.tsx';
import ListAbsoluteMain from '@components/listAbsoluteMain/ListAbsoluteMain.tsx';
import handlerPopup from '@functions/handlerPopup.ts';
import { d, s } from '@functions/seo.ts';
import { CustomListenerT, StoreT } from '@global/types.ts';

import Nav from './components/nav/Nav.tsx';

import getList from './methods/getList.ts';
import getPages from './methods/getPages.ts';
import publicPageScroll from './methods/publicPageScroll.ts';
import updatePagesKey from './methods/updatePagesKey.ts';

import LegalI from './types.ts';

import renderPage from './renders/renderPage.tsx';
import meta from './static/meta.ts';

class Legal extends React.Component<LegalI['props'], LegalI['state']> implements LegalI {
    parent: LegalI['parent'];

    constructor(props: LegalI['props']) {
        super(props);

        let pageUrl;

        if (s() && this.props.seoData?.legalId) {
            pageUrl = this.props.seoData?.legalId;
        }

        this.state = {
            pageUrl,
            shortList: s() ? this.props.seoData.legalShortList : undefined,
        };

        this.publicPageScroll = this.publicPageScroll.bind(this);

        this.parent = React.createRef();
    }

    meta = meta;

    getPages = getPages;
    updatePagesKey = updatePagesKey;
    getList = getList;

    publicPageScroll = publicPageScroll;

    renderPage = renderPage;

    componentDidMount() {
        this.getList();

        (document.addEventListener as CustomListenerT)('publicPageScroll', this.publicPageScroll);
    }

    componentWillUnmount() {
        (document.removeEventListener as CustomListenerT)(
            'publicPageScroll',
            this.publicPageScroll,
        );
    }

    render() {
        const { isSmallMenu, shortList } = this.state;
        const { device, changeLegalCallback } = this.props;

        return (
            <>
                <CustomHead title={this.meta.title} description={this.meta.description} />

                <div className="public__pageInner _full">
                    <div className="publicLegalHeader">
                        {device === 'mobile' && (
                            <>
                                <div
                                    className="publicLegalHeader__listButton _ROW _CLICK"
                                    onClick={() => {
                                        if (shortList) {
                                            handlerPopup('legalNavPopup', {
                                                isShow: true,
                                                list: shortList,
                                            });
                                        }
                                    }}
                                >
                                    Содержание
                                </div>
                            </>
                        )}
                        <div className="publicLegalHeader__inner">
                            {device === 'desktop' && (
                                <div
                                    className={`publicLegalHeader__nav ${shortList ? '_ready' : ''} ${
                                        isSmallMenu ? '_small' : ''
                                    }`}
                                >
                                    <Nav
                                        isSmallMenu={isSmallMenu}
                                        shortList={shortList}
                                        callback={changeLegalCallback}
                                    />
                                </div>
                            )}
                        </div>
                        <ListAbsoluteMain
                            className="publicLegalHeader__pages"
                            items={this.getPages()}
                            renderItem={this.renderPage.bind(this)}
                            classNameItem="publicLegalHeader__page"
                            prop="key"
                            paramsParent={{ width: true }}
                            styles={[]}
                            maxHeight={d.documentElement.clientHeight}
                            isNotParamsItem={true}
                        />
                    </div>
                </div>
            </>
        );
    }
}

function mapStateToProps(state: StoreT) {
    return {
        device: state.device,
        levels: state.levels,
        seoData: state.seoData,
    };
}

export default connect(mapStateToProps)(Legal);
